import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import styles from './index.module.scss'

const SlickSlider = ({
  sliderSettings,
  children,
  dotsClassName,
  classNames,
  name,
}) => {
  const SampleNextArrow = ({ className, onClick }) => {
    return <div className={className} onClick={onClick} />
  }

  const SamplePrevArrow = ({ className, onClick }) => {
    return <div className={className} onClick={onClick} />
  }

  const settings = {
    dots: false,
    infinite: false,
    speed: 150,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    ...sliderSettings,
  }

  return (
    <div className={`slider-${name}`} id="slick-slider">
      <Slider
        {...settings}
        className={`${styles.slider} ${classNames} ${dotsClassName} `}
      >
        {children}
      </Slider>
    </div>
  )
}

export default SlickSlider

SlickSlider.propTypes = {
  sliderSettings: PropTypes.object.isRequired,
  children: PropTypes.array,
  dotsClassName: PropTypes.string,
  name: PropTypes.string,
}
